import { updateData } from "../index";
import { UPDATE_DATA } from "../types";
import { ADD_MASTER_DROPDOWNS, UPDATE_EMPLOYEE_DETAILS } from "./types";

const globalDataReducer = (state = {}, action = updateData) => {
  switch (action.type) {
    case UPDATE_DATA:
      return {
        ...state,
        data: action.payload,
      };

    case ADD_MASTER_DROPDOWNS:
      return {
        ...state,
        masterDropdowns: action.masterDropdowns,
      };

    case UPDATE_EMPLOYEE_DETAILS:
      return {
        ...state,
        employeeInfo: action.employeeInfo,
      };
    default:
      return state;
  }
};
export default globalDataReducer;
